import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../contexts/UserContext";

function ChangePassword() {
  const { user, updateUser } = useUser();
  const navigate = useNavigate();
  const [form, setForm] = useState({ newPassword: "", confirmPassword: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (error) setError("");
  };

  const validate = () => {
    if (!form.newPassword || !form.confirmPassword) {
      setError("Alle felter er påkrævet");
      return false;
    }
    if (form.newPassword !== form.confirmPassword) {
      setError("Adgangskoderne matcher ikke");
      return false;
    }
    if (form.newPassword.length < 8) {
      setError("Adgangskoden skal være mindst 8 tegn");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setIsLoading(true);
    const token = sessionStorage.getItem("token");

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:5000/api"}/auth/change-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ newPassword: form.newPassword }),
      });

      if (!response.ok) {
        const err = await response.text();
        throw new Error(err);
      }

      const data = await response.json();
      if (data.success) {
        updateUser({ ...user, firstLogin: false });
        if (data.token) {
          sessionStorage.setItem('token', data.token);
        }
        setSuccess("Adgangskoden er opdateret");
        // Redirect til dashboard baseret på rolle
        setTimeout(() => {
          if (user.role === "admin") {
            navigate("/admin");
          } else if (user.role === "consultant") {
            navigate("/clients");
          } else {
            navigate(`/client/${user.clientId}/dataexchange`);
          }
        }, 1000);
      } else {
        setError(data.error || "Der opstod en fejl");
      }
    } catch (err) {
      try {
        const jsonErr = JSON.parse(err.message);
        setError(jsonErr.error || "Der opstod en fejl");
      } catch {
        setError(err.message || "Der opstod en fejl");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <h1>Skift adgangskode</h1>
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="error-message" role="alert">
              {error}
            </div>
          )}
          {success && (
            <div className="success-message" role="alert">
              {success}
            </div>
          )}
          <div className="form-group">
            <label htmlFor="newPassword">Ny adgangskode</label>
            <div className="input-with-icon">
              <i className="fas fa-lock"></i>
              <input
                type="password"
                id="newPassword"
                name="newPassword"
                value={form.newPassword}
                onChange={handleChange}
                placeholder="Indtast ny adgangskode"
                required
                disabled={isLoading}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Bekræft adgangskode</label>
            <div className="input-with-icon">
              <i className="fas fa-lock"></i>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                value={form.confirmPassword}
                onChange={handleChange}
                placeholder="Gentag adgangskode"
                required
                disabled={isLoading}
              />
            </div>
          </div>

          <button type="submit" className="login-button" disabled={isLoading}>
            {isLoading ? (
              <span className="loading-spinner">
                <i className="fas fa-spinner fa-spin"></i>
              </span>
            ) : (
              "Opdater adgangskode"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ChangePassword; 